import { featherlight } from './featherlight.js';
import { iframeResizer } from './iframeResizer.js';

export let reports = {
    ajaxUrl: "https://meldungen.city-bahn.de/ajax/",
    selectors: {
        lineContainer: ".cb-report__by-line",
    },
    actions: {
        getImpactedLines: "get_impacted_lines",
    },

    initialise: function () {
        let report = this;

        let $linecontainer = $(report.selectors.lineContainer);
        if ($linecontainer.length) {
            report.lineButtons($linecontainer);
        }

        let seconds = 0;
        let waitForIframe = setInterval(function() {
            seconds++;
            let $iframes = $(".cb-report-iframe:not([data-resizing])")
            $iframes.each(function() {
                let $iframe = $(this);
                $iframe.iFrameResize({heightCalculationMethod: "lowestElement"});
                $iframe.attr("data-resizing", 1)
            })

            if (seconds > 10) {
                clearInterval(waitForIframe);
            }
        },1000)
    },

    postViaAjax: function (action, data) {
        if (!data) {
            data = {};
        }

        return $.ajax({
            url: this.ajaxUrl,
            type: 'post',
            data: this.addAjaxParams(action, data)
        })
    },

    addAjaxParams: function (action, data) {
        data.cbcrep = true
        data.action = action

        return data;
    },

    lineButtons: function($linecontainer) {
        let report = this;

        let $targetelement = $linecontainer;

        if ($linecontainer.find(".e-con-inner").length) {
            $targetelement = $linecontainer.find(".e-con-inner");
        }

        this.postViaAjax(report.actions.getImpactedLines, null)
            .then(function (result) {
                console.log(result)

                if (result.success && result.lines) {
                    $targetelement.append(`<div class="cb-line__btn-container"></div>`)

                    $.each(result.lines, function (index, line) {
                        $targetelement.find(".cb-line__btn-container").append(
                            `<div class=" cb-deco cb-deco--custom cb-ul-hover cb-ul-hover--red">
                            <button class="cb-line__btn" data-featherlight="iframe" href="${line.url}">${line.name}</button>
                            </div>`
                        );
                    });

                    $targetelement.find("button").featherlight({
                        variant: "cb-line-modal"
                    });

                    $linecontainer.show();
                }
            })
    }
}